<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";

export default {
    name: "BreadCrumbWordCloud",
    components: {
        AjaxLoad,
    },
    data() {
        return {
            wordcloud: null,
        }
    },
    computed: {
        idProject() {
            return this.$store.getters.breadCrumbs.event?.EPS_PROJECT_ID?.VALUE || null;
        },
        idWordclouds() {
            return this.$route.params.ID_WORDCLOUDS;
        },
        isActive() {
            return !!(this.idProject && this.idWordclouds)
        },
        breadcrumb() {
            const wordcloud = this.wordcloud,
                dateStart = wordcloud?.date_start,
                dateEnd = wordcloud?.date_end;
            return {
                text: wordcloud &&
                    [dateStart, dateStart !== dateEnd ? dateEnd : null]
                        .filter(v => v)
                        .map(v => this.$moment(v).format('DD.MM.Y'))
                        .join(" - "),
            };
        }
    },
    beforeDestroy() {
        this.$store.commit('UPDATE_BREAD_CRUMBS', {wordcloud: null});
    },
}
</script>

<template>
    <ajax-load
        v-model="wordcloud"
        :active="isActive"
        :url="$apiUrl.getWordCloudUrl({id_project: idProject, id_wordclouds: idWordclouds})"
        :query="{light: 1}"
        :transform="response => response.data.data"
        @input="$store.commit('UPDATE_BREAD_CRUMBS', {wordcloud: $event})"
    >
        <router-view></router-view>
    </ajax-load>
</template>

<style scoped>

</style>